<template>
  <div>
    <div>
      <b-form-group :label="$t('message.Название') + '(RU):'" label-for="Name">
        <b-form-input id="Name" type="text" v-model="model.name" required>
        </b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('message.Название') + '(EN):'"
        label-for="Name_EN"
      >
        <b-form-input id="Name_EN" type="text" v-model="model.name_en">
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox v-model="model.extended" switch>
          {{ $t("message.Категории_-_Extended") }}</b-form-checkbox
        >
      </b-form-group>
      <b-form-group :label="$t('message.Логотип')" label-for="Logo">
        <b-form-file
          accept="image/*"
          v-model="model.image"
          @change="onFileChange"
          :state="Boolean(model.image)"
          placeholder="Choose a file..."
        ></b-form-file>
        <div class="mt-3" v-if="model.image_url">
          <img :src="model.image_url" width="64" />
        </div>
      </b-form-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "CategoryForm",
  props: ["model"],
  data() {
    return {};
  },
  created: function() {},
  mounted: function() {},
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function() {
          this.model.image = reader.result;
        }.bind(this),
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/CategoriesForm.vue